<template>
  <div>The future phase's update plan</div>
</template>

<script>
export default {

}
</script>

<style>

</style>